<template>
    <div class="embed-responsive embed-responsive-16by9" id="player-container">
        <video
            class="embed-responsive-item video-js vjs-big-play-centered"
            ref="videoPlayer"
            :poster="poster"
            autoplay
            controls
            playsinline></video>
        <button @click="unmute" v-if="showingUnmute && !showedUnmute" class="inner btn btn-secondary btn-vjs">Clicca per attivare l'audio</button>
    </div>
</template>

<script>
import videojs from 'video.js';
import { registerIVSTech, registerIVSQualityPlugin } from 'amazon-ivs-player';

registerIVSTech(videojs, {
    wasmWorker: '/assets/ivs/amazon-ivs-wasmworker.min.js',
    wasmBinary: '/assets/ivs/amazon-ivs-wasmworker.min.wasm',
});
registerIVSQualityPlugin(videojs);

export default {
    name: "Player",
    props: {
        src: String,
        poster: {
            type: String,
            default: "/image/cover"
        }
    },
    data() {
        return {
            player: null,
            showingUnmute: false,
            showedUnmute: false,
        }
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, {
            techOrder: ['AmazonIVS']
        }, () => {
            console.log('Player ready');
            this.player.src(this.src)
        })
        this.player.enableIVSQualityPlugin();

        this.player.on('play', () => {
            this.showingUnmute = true;
            console.log('play');
        });

        this.player.on('pause', () => {
            this.showingUnmute = false;
            console.log('pause');
        });

        /*this.player.on('volumechange', (test) => {
            console.log('volumechange', test, this.player.userActive());

            this.showedUnmute = true;
        })*/

        /*// +++ Wait for loadedmetadata then try to play video +++
        this.player.on("loadedmetadata", function() {
            // Play video which returns a promise
            var promise = this.player.play();
            console.log("promise", promise);

            // +++ Use promise to see if video is playing or not +++
            if (promise !== undefined) {
                promise
                    .then(() => {
                        // Autoplay started!
                        // If video playing unmute and set the volume
                        this.player.muted(false);
                        this.player.volume(volumeLevel);
                    })
                    .catch((error) => {
                        // Autoplay was prevented.
                        // // +++ If autoplay prevented mute the video, play video and display unmute button +++
                        this.player.muted(true);
                        this.player.play();

                        this.showingUnmute = true;
                    });
            }
        });
         */
    },
    methods: {
        unmute() {
            this.player.muted(false);
            this.showedUnmute = true;
        }
    }
}
</script>

<style scoped>
    .video-js {
        height: 100%;
        width: 100%;
    }

    /* Style inner div to center button */
    .inner {
        left: 50%;
        top: 10%;
        transform: translate(-50%, -50%);
        position: absolute;
    }

    .btn-vjs {
        background-color: rgba(43,51,63,.8);
    }
</style>
